import { gql } from '@apollo/client';

export const DELETE_DOCUMENT_MUTATION = gql`
  mutation RemoveDocument($id: Int!) {
    removeDocument(id: $id) {
      id
    }
  }
`;